import { Routes } from '@angular/router';
import { AboutComponent } from './about.component';
import { AboutType01Component } from './about-type01/about-type01.component';
import { AboutType02Component } from './about-type02/about-type02.component';
import { AboutType03Component } from './about-type03/about-type03.component';

export default [
    
    { path : '', component: AboutComponent,
        
    },
    
] as Routes;
